import React, { FunctionComponent } from 'react';
import { View } from '@upstox/upstox-ui';
import { Ipo } from 'store/types';
import IPOHeader from '../IPOHeader';
import IPOInfo from '../IPOInfo';
import IPOTimeLine from '../IPOTimeLine';
import * as css from './IPODetailsCard.style';

interface Props {
  ipoDetails: Ipo;
  headerStatus: string;
  headerTagColor?: TagColors;
  isSeoApp?: boolean;
}

export const IPODetailsCard: FunctionComponent<Props> = ({
  ipoDetails,
  headerStatus,
  headerTagColor,
  isSeoApp = false,
}) => {
  return (
    <View flexDirection="column" css={css.ipoInfoCard}>
      <IPOHeader
        ipoIcon={ipoDetails?.logoUrl}
        ipoName={ipoDetails?.name}
        logoMeta={ipoDetails?.logoMeta}
        ipoSymbol={ipoDetails?.symbol}
        minPrice={ipoDetails?.minPrice}
        maxPrice={ipoDetails?.maxPrice}
        status={headerStatus}
        tagColor={headerTagColor}
      />

      <IPOInfo
        isSeoApp={isSeoApp}
        biddingStartDate={ipoDetails?.biddingStartDate}
        biddingEndDate={ipoDetails?.biddingEndDate}
        lotSize={ipoDetails?.lotSize}
        issueSize={ipoDetails?.issueSize}
        minPrice={ipoDetails?.minPrice}
        minQuantity={ipoDetails?.minBidQuantity}
      />

      <IPOTimeLine
        isSeoApp={isSeoApp}
        biddingStartDate={ipoDetails?.biddingStartDate}
        biddingEndDate={ipoDetails?.biddingEndDate}
        allotmentDate={ipoDetails?.detail?.allotmentDate}
        refundInitiationDate={ipoDetails?.detail?.refundDate}
        dematTransferDate={ipoDetails?.detail?.creditDate}
        listingDate={ipoDetails?.detail?.listingDate}
      />
    </View>
  );
};
